module.exports = __webpack_public_path__ + "img/center_center.8f11c195.svg";